/* eslint-disable */
export default {
  cancel: 'Annulla',
  confirm: 'Conferma',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirm"@#@ @source: @#@"Confirm"@#@
